const DEFAULT_INDICATOR_AND_OVERLAY_SYMBOL = '$SPX';

export {
  DEFAULT_INDICATOR_AND_OVERLAY_SYMBOL
};